// extracted by mini-css-extract-plugin
module.exports = {"enterName":"BioIntake_enterName__3Mnqh","fadein":"BioIntake_fadein__1V8yq","biodataIntake":"BioIntake_biodataIntake__1gbU0","bioIntakeHeader":"BioIntake_bioIntakeHeader__3_UiF"};